import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '@app/_helpers';

@Pipe({
  name: 'precision'
})
export class PrecisionPipe implements PipeTransform {

  transform(value: any, precision: number): unknown {
    return Utils.precisionUtil(value, precision);
  }

}
